export default __webpack_public_path__ + "static/media/document.21d0dd50.jpg";